import { Link } from "react-router-dom";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FadeUp, MaskedLines } from "@/components/Reveal";

const FAQS = [
  {
    q: "What exactly is Vibe?",
    a: "Vibe is a drinkable powder sachet made for your morning skin-care routine. Tear it open, mix with water, and drink — a small ritual, once a day.",
  },
  {
    q: "How do I use it?",
    a: "Once each morning, with or after breakfast. Mix one sachet with water.",
  },
  {
    q: "When will I see results?",
    a: "Results vary from person to person and are not guaranteed. Consistency is what matters: keep the ritual going and give your skin time.",
  },
  {
    q: "Can it replace my prescribed acne treatment?",
    a: "No. Vibe is not a medicine and is not intended to diagnose, treat or replace prescribed acne treatment. If you're under treatment, keep it.",
  },
  {
    q: "Do you ship across India?",
    a: "Yes — shipping is free across India, and orders typically arrive within a few business days.",
  },
  {
    q: "What if something's wrong with my order?",
    a: "Write to helpdesk@getvibe.co.in with your order number and we'll sort it out with you — unopened packs can be returned.",
  },
];

export default function Faqs() {
  return (
    <div data-testid="page-faqs">
      <section className="mx-auto max-w-[88rem] px-5 sm:px-10 pt-[7.5rem] lg:pt-[8.5rem] pb-24 lg:pb-36">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <FadeUp>
              <p className="text-xs uppercase tracking-[0.26em] text-[#4A6B56] mb-6">Questions</p>
              <h1 className="font-display text-[clamp(2.7rem,5.5vw,5rem)] leading-[1.02] tracking-tight text-[#1B4332]">
                <MaskedLines onView lines={["Good questions,", "honest answers."]} />
              </h1>
              <p className="mt-8 max-w-sm text-lg text-[#4A6B56] leading-relaxed">
                Everything you need to know about Vibe, claims, and our guarantees. Something
                missing? Write to{" "}
                <a
                  href="mailto:helpdesk@getvibe.co.in"
                  data-testid="faqs-email-link"
                  className="text-[#1B4332] underline underline-offset-4"
                >
                  helpdesk@getvibe.co.in
                </a>
              </p>
            </FadeUp>
          </div>

          <div className="lg:col-span-7">
            <FadeUp delay={0.1}>
              <Accordion type="single" collapsible className="w-full" data-testid="faqs-accordion">
                {FAQS.map((faq, i) => (
                  <AccordionItem key={i} value={`item-${i}`} className="border-[#D1E2D6]">
                    <AccordionTrigger
                      data-testid={`faq-trigger-${i}`}
                      className="font-display text-2xl sm:text-[1.7rem] text-[#1B4332] text-left py-6 hover:no-underline hover:text-[#2D5A44] transition-colors"
                    >
                      {faq.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#4A6B56] text-base leading-relaxed pb-6 max-w-xl">
                      {faq.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </FadeUp>
          </div>
        </div>
      </section>
    </div>
  );
}
